import { Link } from "react-router-dom";
import { classNames } from "../../shared/utility";
import ButtonSpinner from "./ButtonSpinner";

const VARIANT_CLASSES = {
  primary: "btn-primary text-white focus-visible:outline-accent",
  secondary:
    "border border-border bg-card text-brand hover:bg-accent-soft focus-visible:outline-accent",
  danger:
    "bg-red-600 text-white hover:bg-red-500 focus-visible:outline-red-600",
  success:
    "bg-green-600 text-white hover:bg-green-500 focus-visible:outline-green-600",
  info: "bg-sky-600 text-white hover:bg-sky-500 focus-visible:outline-sky-600",
};

const BASE_CLASSES =
  "inline-flex items-center justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50";

export default function Button(props) {
  const {
    variant = "primary",
    to,
    href,
    loading = false,
    disabled = false,
    className,
    type = "button",
    children,
    ...rest
  } = props;

  const classes = classNames(
    BASE_CLASSES,
    VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary,
    className,
  );

  const content =
    loading && typeof children === "string" ? (
      <ButtonSpinner spin text={children} />
    ) : (
      children
    );

  const isDisabled = disabled || loading;

  if (to) {
    if (isDisabled) {
      return (
        <span
          className={classNames(classes, "pointer-events-none opacity-50")}
          aria-disabled="true"
        >
          {content}
        </span>
      );
    }
    return (
      <Link to={to} className={classes} {...rest}>
        {content}
      </Link>
    );
  }

  if (href) {
    if (isDisabled) {
      return (
        <span
          className={classNames(classes, "pointer-events-none opacity-50")}
          aria-disabled="true"
        >
          {content}
        </span>
      );
    }
    return (
      <a href={href} className={classes} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button
      type={type}
      className={classes}
      disabled={isDisabled}
      {...rest}
    >
      {content}
    </button>
  );
}
